<template>
  <Card class="DealFilterResultInfoBar">
    <div class="row">
      <!-- Number of suppliers -->
      <div class="col-12 col-md-4 border">
        <DealFilterResultInfoBarItem>
          <template slot="label">
            {{ $t('filterResultsInfoBarSuppliers') }}
          </template>
          <template slot="value">
            {{ data.numberOfSuppliers }}
          </template>
        </DealFilterResultInfoBarItem>
      </div>
      <!-- /Number of suppliers -->

      <!-- Price difference -->
      <div class="col-12 col-md-4 border">
        <DealFilterResultInfoBarItem>
          <template slot="label">
            {{ $t('filterResultsInfoBarPriceDifference') }}
          </template>
          <template slot="value">
            {{ data.percentagePriceDiff | formatNumber }}%
          </template>
        </DealFilterResultInfoBarItem>
      </div>
      <!-- /Price difference -->

      <!-- Cheapest price -->
      <div class="col-12 col-md-4 border">
        <DealFilterResultInfoBarItem>
          <template slot="label">
            {{ $t('filterResultsInfoBarCheapestPrice') }}
          </template>
          <template slot="value">
            {{ data.lowestPrice | formatNumber }}
          </template>
        </DealFilterResultInfoBarItem>
      </div>
      <!-- /Cheapest price -->
    </div>
  </Card>
</template>

<script>
import Card from '@/components/Card.vue';
import DealFilterResultInfoBarItem
  from '@/components/dealFilter/ResultInfoBarItem.vue';

export default {
  name: 'DealFilterResultInfoBar',
  components: {
    Card,
    DealFilterResultInfoBarItem,
  },
  props: {
    data: {
      type: [Object, Array],
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.DealFilterResultInfoBar {
  background: $color--primary;
}
.border {
  border-bottom: 1px solid rgba(255,255,255,0.25);

  &:last-child {
    border-bottom: 0;
  }
}
@include media-md() {
  .border {
    border-bottom: 0;
    border-right: 1px solid rgba(255,255,255,0.25);

    &:last-child {
      border-right: 0;
    }
  }
}
</style>
